import { Schema } from '@blade/std-lib'

export class RedditResizePostMessage extends Schema.Class<RedditResizePostMessage>(
  'RedditResizePostMessage',
)({
  data: Schema.Number,
  type: Schema.Literal('resize.embed'),
}) {
  static decode = Schema.decodeUnknownOption(
    Schema.fromJsonString(RedditResizePostMessage),
  )
}
